export default __webpack_public_path__ + "img/Montserrat-Thin_8067c90.eot";